<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('production.ribbon_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-md-7">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.color_name"
          name="common_words.name"
          v-validate="modelValidations.color_name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('production.ribbon_name')}...`"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('production.ribbon_color') }}</label>
          <sketch-picker :value="colors" @input="updateValue"></sketch-picker>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('common_words.text_color') }}</label>
          <sketch-picker :value="colorst" @input="updateValueT"></sketch-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinColors from 'src/util/mixinColor';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  data() {
    return {
      model: {
        color_name: null,
        color: null,
        color_text: null,
      },
      modelValidations: {
        color_name: {
          required: true,
        },
        color: {
          required: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, MixinColors],
  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        this.$emit('fillRibbonForm', 'firstStep');
        return res;
      });
    },

    updateValueT(value) {
      this.model.color_text = value.hex;
    },
  },

  mounted() {
    let editForm = {};
    this.model.color = this.colors;
    this.model.color_text = this.colorst;
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.color = editForm.color_code;
      this.model.color_name = editForm.color_name;
      this.model.color_text = editForm.color_text;
      this.colors = this.model.color;
      this.colorst = this.model.color_text;
      this.forceRerender();
    }
  },
};
</script>
<style></style>
